import React, { Component } from 'react';
import { translate } from '../../Services/translation';

class CasallProPurchaseMultiSizeInput extends Component {
    constructor(props) {
        super(props);

    }

    componentDidMount() {
        this.props.updateData(JSON.parse(this.props.sizeinputfields))
        this.props.setDefaultData(JSON.parse(this.props.sizeinputfields))
    }

    updateField(e) {
        const { sizeData } = this.props;
        const id = e.target.id;
        const value = e.target.value;

        sizeData.map(item => {
            if (item.fieldId === id) {
                item.fieldValue = value;
            }
        });

        this.props.updateData(JSON.parse(JSON.stringify(sizeData)))
    }

    updateInputs(sizeData) {
        if (!sizeData) return;
        sizeData.forEach(size => {
            const input = document.getElementById(size.fieldId)
            if (input) {
                if (input.value !== size.fieldValue)
                    input.value = size.fieldValue === 0 ? "" : size.fieldValue
            }
        })
    }

    showMore() {
        const { sizeData } = this.props;
        sizeData.map(item => {
            item.visible = true;
        });

        this.props.updateData(JSON.parse(JSON.stringify(sizeData)))
    }

    render() {
        const {errors } = this.props;        
        this.updateInputs(sizeData);
        const productType = this.props.producttype;
        let sizeData = this.props.sizeData
        
        if (productType === "Item") {
            sizeData = sizeData.filter(item => item.articleNumber == this.props.productid)
        }
        return (
            <div className="sizeInput-container">
                <div className="sizeInput-header">{productType === "Master" ? translate('sizeInput.header') : translate('sizeInput.item.header')}</div>
                <div className="row">
                    { sizeData && sizeData.filter(item => item.visible === true).map((item, index) => {
                        const showError = errors && errors['errorsList'] && errors['errorsList'][`articleSizeInputField.${item.fieldId}`];
                        const isQuotation = this.props.offert === "True" || this.props.offert;
                        return (
                            <div key={item.fieldId} className="sizeInput-column">
                                {
                                    <div className="sizeInput-sizeHeader">
                                        <label for={item.fieldId} className="sizeInput-label">
                                            {item.mastervariant}
                                        </label>
                                        { this.props.loggedouttext ?
                                            null
                                            : ( (!isQuotation || isQuotation === "False") ? (
                                                    <div className="sizeInput-priceText">
                                                        {item.price}*
                                                    </div>
                                                ) : null
                                            )
                                        }
                                    </div>
                                }
                                <input 
                                    className={`sizeInput-input`}
                                    type="numeric" 
                                    id={item.fieldId}
                                    onBlur={ e => this.updateField(e) }
                                    placeholder="-"/>
                                { showError && <span className="form__validator--error">{errors['errorsList'][`articleSizeInputField.${item.fieldId}`]}</span>}
                                { (!isQuotation || isQuotation === "False") && !this.props.loggedouttext && <div className="sizeInput-stockText">({item.stockStatusText})</div>}
                            </div>
                            )
                    })}
                    { sizeData && sizeData.some(item => item.visible === false) &&
                     <div className="sizeInput-column">
                         <label className="sizeInput-label"> </label>
                         <div onClick={() => this.showMore()} className="sizeInput-showMore">{"+" + sizeData.filter(item => item.visible === false).length}</div>
                     </div>
                     }
                </div>
                {errors && errors['articles'] && <span className="form__validator--error">{errors['articles'][0]}</span>}
            </div>
        )
    }
}

export default CasallProPurchaseMultiSizeInput;
